export const PERMISOS_TEMPLATE = [
  { name: "students", label: "Alumnos" },
  { name: "courses", label: "Cursos" },
  { name: "courseTurns", label: "Grupos" },
  { name: "stats", label: "Estadísticas" },
  { name: "instructors", label: "Instructores" },
  { name: "moves", label: "Finanzas" },
  { name: "transfers", label: "Transferencias" },
  { name: "users", label: "Usuarios" },
  { name: "settings", label: "Configuración" },
  // Giving MercadoPago payments back (real money leaves the account). Only
  // "Nuevo" means anything here: it lets the role refund from Pagos MP.
  { name: "mpRefunds", label: "Devoluciones MP", levels: [2] },
];

export const SECCION_PERMISOS = {
  modulo: 0,
  ver: 1,
  crear: 2,
  editar: 3,
  eliminar: 4,
};
